/**
 * Money, for display only (ORDR-42).
 *
 * Formats ONE server figure in minor units. It sums nothing and derives
 * nothing: the total a diner sees is always the server quote's `total_minor`.
 */
export function formatMinor(amountMinor: number, currency: string): string {
  return new Intl.NumberFormat(undefined, { style: "currency", currency }).format(amountMinor / 100);
}
